module.exports = "pegasus/assets/notes-card.png";